/**
 * Tipo de evento (`janis.catalog.product.batch`) para columnas angostas.
 *
 * Si no cabe, se parte DESPUES DE UN PUNTO y no en cualquier letra: con
 * `overflow-wrap: anywhere` solo, "syncro.product.saved.janis" terminaba como
 * "syncro.produc / t.saved.janis", que no se lee como ninguno de sus segmentos.
 * Los `<wbr>` ofrecen el corte en los puntos; el navegador parte a mitad de
 * segmento solo si un segmento no cabe entero.
 *
 * El texto sigue siendo uno solo para buscar y copiar: `<wbr>` no agrega
 * caracteres.
 */
import { Fragment } from 'react';
import type { ReactElement } from 'react';

export function EventName({ value }: { readonly value: string | null }): ReactElement {
  if (value === null) {
    return <>—</>;
  }
  const segments = value.split('.');
  return (
    <>
      {segments.map((segment, index) => (
        // Los segmentos pueden repetirse ("a.b.a"): la posición es la identidad.
        <Fragment key={index}>
          {segment}
          {index < segments.length - 1 ? (
            <>
              .<wbr />
            </>
          ) : null}
        </Fragment>
      ))}
    </>
  );
}
